module.exports = __webpack_public_path__ + "img/zfb.c2dc2575.png";